import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-asana',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Asana icon</title><path d="M18.78 12.653c-2.882 0-5.22 2.336-5.22 5.22s2.338 5.22 5.22 5.22 5.22-2.34 5.22-5.22-2.336-5.22-5.22-5.22zm-13.56 0c-2.88 0-5.22 2.337-5.22 5.22s2.338 5.22 5.22 5.22 5.22-2.338 5.22-5.22-2.336-5.22-5.22-5.22zm12-6.525c0 2.883-2.337 5.22-5.22 5.22-2.882 0-5.22-2.337-5.22-5.22 0-2.88 2.338-5.22 5.22-5.22 2.883 0 5.22 2.34 5.22 5.22z"/></svg>`,
    styles: []
})
export class SimpleIconsAsanaComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#273347';
    @Input() className: string = 'simple-icons-asana'
    constructor() {}
    ngOnInit(): void {}
}
